import React, { useState, useEffect } from "react";
import { farmers, taskAssign } from "../../config/images";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { Button } from "../../components/Button/button";
import { Grid, Box, Tabs, Tab, Typography } from "@mui/material";
import PersonalDetails from "./PersonalDetails";
import LocationDetails from "./LocationDetails";
import FarmingDetails from "./FarmingDetails";
import FarmOwnershipDetails from "./FarmOwnershipDetails";
import AccessToFinance from "./AccessToFinance";
import translations from "../../config/language";

const PreviewFarmersDetails = ({
  isPreviewClick,
  setIsPreviewClick,
  selectedFarmer,
}) => {
  const handleReject = () => { };

  const handleApproved = () => { };


  const [firstName, middleName, lastName] = selectedFarmer.farmerName.split(" ");


  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const language = process.env.REACT_APP_LANGUAGE;

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box className="task-assign-box">
            <Box className="d-flex justify-content-between" style={{ flexWrap: "wrap" }}>
              <Box className="d-flex p-3 gap-3 img-box">
                <img src={taskAssign.union} alt="" />
                <Typography variant="h6" gutterBottom>
                  {translations[language].farmersDetailsView}
                </Typography>
              </Box>
              <Box className="edit-profile">

                <button
                  title="Reject"
                  classname={"border-btn"}
                  style={{
                    backgroundColor: "#fff", color: "#31A05F",
                    border: "1px solid #31A05F",
                    borderRadius: "6px", padding: "9px 22px"
                  }}
                  onClick={handleReject}
                  disabled={activeTab != 4}
                >{translations[language].reject} </button>
                <Button
                  title={translations[language].approved}
                  classname={"custom-button"}
                  activeTab={activeTab != 4}
                //   onClick={handleApproved}
                />

              </Box>
            </Box>

            {/* Tab Selection */}
            <Box sx={{ width: "max-content", pt: 2 }}>
              <Tabs value={activeTab}
                onChange={handleTabChange}
                className="custom-tabs"
                TabIndicatorProps={{ style: { display: "none" } }}
              >
                <Tab label={translations[language].personalDetails} />
                <Tab label={translations[language].locationDetails} />
                <Tab label={translations[language].farmingDetails} />
                <Tab label={translations[language].farmOwnershipDetails} />
                <Tab label={translations[language].accessToFinance} />
              </Tabs>
            </Box>


            {/* Dynamic Tab Content */}
            <div className="tab-content">
              {activeTab === 0 && <PersonalDetails selectedFarmer={selectedFarmer} />}
              {activeTab === 1 && <LocationDetails selectedFarmer={selectedFarmer} />}
              {activeTab === 2 && <FarmingDetails selectedFarmer={selectedFarmer} />}
              {activeTab === 3 && <FarmOwnershipDetails selectedFarmer={selectedFarmer} />}
              {activeTab === 4 && <AccessToFinance selectedFarmer={selectedFarmer} />}
            </div>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default PreviewFarmersDetails;
